import { Box, Grid, Theme, useMediaQuery } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { ProfileNavigationSkeleton } from './ProfileNavigationSkeleton';
import { profileLayoutStyles } from './styles';

export const ProfileLayoutSkeleton: React.FC = () => {
  const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  return (
    <Box>
      <Grid container>
        {!isTablet && (
          <Grid item>
            <ProfileNavigationSkeleton />
          </Grid>
        )}
        <Grid item xs>
          <Box sx={profileLayoutStyles.outletWrapper}>
            <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
